// import * as dotenv from 'dotenv';
// type Env = 'development' | 'production';
export class Config {
    constructor() {
        // dotenv.config();
        const node_env = process.env.NODE_ENV;
        // USE_EMULATOR lets a minified production build still target the local
        // emulators (used by the E2E suite) without running React in dev mode.
        this.isDev = node_env === 'development' || process.env.USE_EMULATOR === 'true';
        this.apiUrl = this.isDev
            ? 'http://127.0.0.1:5001/stanorai-outreach/us-central1/api'
            : 'https://us-central1-stanorai-outreach.cloudfunctions.net/api';
    }
}
